module.exports = __webpack_public_path__ + "img/logo.8caf34d7.png";